import { render, staticRenderFns } from "./StyledTableReport.vue?vue&type=template&id=9c920cdc&scoped=true&"
import script from "./StyledTableReport.vue?vue&type=script&lang=js&"
export * from "./StyledTableReport.vue?vue&type=script&lang=js&"
import style0 from "./StyledTableReport.vue?vue&type=style&index=0&id=9c920cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c920cdc",
  null
  
)

export default component.exports